// src/lib/emailLead.js
//
// Sends website form submissions straight to frank.balz@hambacore.com via
// EmailJS (client-side, no backend). Used by HeroLeadForm (short) and
// AnfrageForm (two-step).
//
// ⚠️ EmailJS delivers to whatever the TEMPLATE's "To Email" field is set to in
// the EmailJS dashboard. For `to_email` below to take effect, that field must be
// `{{to_email}}` — otherwise set it directly to frank.balz@hambacore.com.
// Recommended template body: a single {{message}} block (pre-formatted here),
// with {{reply_to}} as the template's "Reply To".
import emailjs from 'emailjs-com';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_d41315s';
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_ml7sfur';
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'vL8w8y040x5rEcv7u';
const TO_EMAIL = process.env.REACT_APP_LEAD_TO_EMAIL || 'frank.balz@hambacore.com';

/**
 * @param {object} opts
 * @param {string} opts.formType  human label, e.g. "Erstanalyse-Anfrage"
 * @param {Record<string,string>} opts.fields  ordered label→value pairs
 * @param {string} [opts.replyTo]  applicant email for the Reply-To header
 * @returns {Promise} resolves on success, rejects on failure
 */
export function sendLead({ formType, fields, replyTo }) {
  // The whole submission goes into ONE pre-formatted {{message}} variable — this
  // is what the EmailJS template must render. Field-by-field variables are avoided
  // on purpose: the German labels contain spaces ("E-Mail") which are not valid
  // EmailJS variable names, so they silently render blank (the "empty email" bug).
  const message = [
    `NEUE ${formType.toUpperCase()}`,
    '',
    ...Object.entries(fields).map(([k, v]) => `${k}: ${v && String(v).trim() ? v : '—'}`),
  ].join('\n');

  const from_name =
    fields.Name || `${fields.Vorname || ''} ${fields.Nachname || ''}`.trim() || 'Website-Lead';

  // Only clean, space-free variable names — these map 1:1 to {{...}} in the template.
  return emailjs.send(
    SERVICE_ID,
    TEMPLATE_ID,
    {
      to_email: TO_EMAIL,
      subject: `Neue ${formType} — hambacore.com`,
      from_name,
      reply_to: replyTo || '',
      form_type: formType,
      message,
    },
    PUBLIC_KEY,
  );
}
